<dashboard-loader *ngIf="loadingModules$ | async" [title]="'Loading modules...'"></dashboard-loader>
<div class="dashboard-modules" fxLayout="row" fxLayoutAlign="space-around start">
  <div class="dashboard-modules__left" fxLayout="column" fxLayoutAlign="space-around start" fxFlex="40">
    <h1 class="dashboard-modules__left-title">Modules</h1>
    <div
      class="dashboard-modules__left-link"
      fxLayout="row"
      fxLayoutAlign="space-between center"
      *ngIf="
        privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.INTERVENTIONS, PRIVILEGE_ACTIONS.ALL) &&
        !(!allModules?.length || (allModules?.length === 1 && !allModules[0]?.name))
      "
    >
      Click &nbsp; <a [routerLink]="getInterventionsUrl()">here</a> &nbsp;to add modules to interventions
    </div>
    <div fxLayout.gt-lg="row" fxLayout.lt-xl="column" fxFill>
      <div class="dashboard-modules__left-button">
        <button
          mat-raised-button
          color="accent"
          (click)="createModule()"
          [disabled]="!isEdit"
          *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.ALL)"
        >
          {{ 'Create New Module' | uppercase }}
        </button>
      </div>
      <div class="dashboard-modules__left-filter" fxLayoutGap="20px">
        <mat-form-field>
          <button matSuffix mat-icon-button aria-label="Search">
            <mat-icon>search</mat-icon>
          </button>
          <input [(ngModel)]="searchModules" (ngModelChange)="filterModules()" matInput placeholder="Search by title" />
        </mat-form-field>
        <mat-form-field style="max-width: 130px; width: auto">
          <mat-label>Sort by</mat-label>
          <mat-select>
            <mat-option
              #sortOption
              *ngFor="let option of sortOptions"
              [value]="option.value"
              (click)="sort(sortOption.value)"
            >
              {{ option.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <mat-card *ngIf="!allModules?.length || (allModules?.length === 1 && !allModules[0]?.name)">
      There are no modules in this study yet
    </mat-card>
    <div fxFill>
      <virtual-scroller #scroll class="dashboard-modules__left-scroll" [items]="sortedModules">
        <mat-card *ngFor="let module of scroll.viewPortItems" class="dashboard-modules__left-scroll-module-card">
          <ng-container *ngIf="module?.name">
            <mat-card-header>
              <mat-card-title class="dashboard-modules__left-scroll-module-card-title">
                {{ module?.name }}
              </mat-card-title>
            </mat-card-header>
            <mat-card-content class="dashboard-modules__left-scroll-module-card-content">
              <div class="dashboard-modules__left-scroll-module-card-content-text">
                <div
                  *ngIf="module?.translations | dashboardTranslate: 'title':selectedLanguage?.code as moduleTitle"
                  class="dashboard-modules__left-scroll-module-card-content-text-title"
                >
                  {{ moduleTitle }}
                </div>
                <div
                  *ngIf="
                    module?.translations | dashboardTranslate: 'description':selectedLanguage?.code as moduleDescription
                  "
                >
                  {{ moduleDescription }}
                </div>
              </div>
            </mat-card-content>
            <mat-divider [inset]="true"></mat-divider>
            <mat-card-actions
              class="dashboard-modules__left-scroll-module-card-actions"
              fxLayout="row"
              fxLayoutAlign="end center"
            >
              <ng-container *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.ALL)">
                <button mat-button color="warn" (click)="openDeleteDialog(module)">
                  {{ 'Delete' | uppercase }}
                </button>
                <button mat-button (click)="duplicateModule(module)">
                  {{ 'Duplicate' | uppercase }}
                </button>
              </ng-container>
              <button mat-button (click)="openModuleDetails(module)">
                {{ 'Open' | uppercase }}
              </button>
            </mat-card-actions>
          </ng-container>
        </mat-card>
      </virtual-scroller>
    </div>
  </div>
  <div class="dashboard-modules__center">
    <div class="dashboard-modules__center-line"></div>
  </div>
  <div
    class="dashboard-modules__right"
    fxLayout="column"
    fxLayoutAlign="space-around stretch"
    fxLayoutGap="40px"
    fxFlex="50"
  >
    <div *ngIf="isEdit; else newModule">
      <mat-tab-group
        mat-stretch-tabs
        dynamicHeight
        class="dashboard-modules__right-group"
        fxLayout="column"
        fxLayoutAlign="center"
        fxFill
        (selectedTabChange)="onSelectedTabChange($event)"
        [(selectedIndex)]="selectedTabIndex"
      >
        <mat-tab [label]="MODULES_TAB_LABELS.GENERAL">
          <dashboard-module-form [isEdit]="isEdit" fxFill></dashboard-module-form>
        </mat-tab>
        <mat-tab [label]="MODULES_TAB_LABELS.CONTENT_ITEMS">
          <dashboard-module-item-list [isScreening]="false" fxFill></dashboard-module-item-list>
        </mat-tab>
      </mat-tab-group>
    </div>
    <ng-template #newModule>
      <h1 class="dashboard-modules__right-title">
        {{
          privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.ALL)
            ? selectedModule
              ? ''
              : 'Create New Module'
            : 'Please select a Module'
        }}
      </h1>
      <dashboard-module-form [isEdit]="isEdit" fxFill></dashboard-module-form>
    </ng-template>
  </div>
</div>
